import { Popover } from 'antd';
import { X, IconProps } from 'react-feather';
import { Link } from 'react-router-dom';
import ActionIcon from '../ActionIcon';

interface Props extends IconProps {
  redirect?: string;
  disabled?: boolean;
  popover?: string;
  onClick?: () => void;
}

const CloseIcon: React.FC<Props> = ({
  redirect,
  disabled,
  popover,
  ...props
}) => {
  const icon = (
    <X
      size={20}
      cursor="pointer"
      {...props}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : 'red',
      }}
    />
  );

  return (
    <Popover content={popover ?? 'Cancelar'} className="edit-icon">
      {redirect ? (
        <Link to={redirect}>{icon}</Link>
      ) : (
        <ActionIcon onClick={!disabled ? props?.onClick : undefined}>
          {icon}
        </ActionIcon>
      )}
    </Popover>
  );
};

export default CloseIcon;
